import {
  IInfluencer,
  INFLUENCER_ACCOUNT_STATUS,
} from "@shared/lib/types/influencer";

import styles from "./styles.module.scss";
import { SocialMediaList } from "@entities/influencer/ui/SocialMedia/SocialMediaList";
import { ContactsList } from "@entities/influencer/ui/ContactList/ContactList";
import { ReviewList } from "@entities/influencer/ui/Reviews/ReviewList";
import { Space, Switch } from "antd";
import { useUpdateInfluencer } from "@entities/influencer";
import { SelectInfluencer } from "./SelectInfluencer";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { LinkedAgencyList } from "@entities/influencer/ui/LinkedAgencyList/LinkedAgencyList";
import { useGetBriefsByInfId } from "@entities/brief/lib/hooks/useGetBriefsByInfId";
import { Campaigns } from "@entities/influencer/ui/Campaigns/Campaigns";

interface Props {
  influencer?: IInfluencer;
  socialMediaId?: string;
  handleRefetch: () => void;
  categoriesToDisplay: string[];
}

export function InfluencerDetails({
  influencer,
  socialMediaId,
  handleRefetch,
  categoriesToDisplay,
}: Props) {
  const influencerId = influencer?._id || "";

  const { update, isUpdating, isUpdated } = useUpdateInfluencer();

  useEffect(() => {
    if (isUpdated) {
      ToastService.success("Influencer updated successfully");
      handleRefetch();
    }
  }, [isUpdated]);

  if (influencer) {
    return (
      <div className={styles.container}>
        <SocialMediaList
          socialMedias={influencer.socialMedias || []}
          influencerId={influencerId}
        />
        <Campaigns infId={influencerId} />
        <ContactsList
          contacts={influencer.contacts || []}
          influencerId={influencerId}
          linkedAgencies={influencer.linkedAgencies || []}
        />
        <LinkedAgencyList
          linkedAgencies={influencer.linkedAgencies || []}
          influencerId={influencerId}
        />
        <ReviewList
          reviews={influencer.reviews || []}
          influencerId={influencerId}
        />

        <div className={styles.card}>
          <Space
            style={{
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div>
              <div className={styles.permItemTitle}>Archive</div>
              <div className={styles.permItemDesc}>Archive this creator</div>
            </div>
            <Switch
              checked={influencer.isArchived}
              onChange={(value) =>
                update({ influencerId, influencer: { isArchived: value } })
              }
              loading={isUpdating}
            />
          </Space>
        </div>
        <div className={styles.card}>
          <Space
            style={{
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <div>
              <div className={styles.permItemTitle}>Blacklist</div>
              <div className={styles.permItemDesc}>Blacklist this creator</div>
            </div>
            <Switch
              checked={
                influencer.accountStatus ===
                INFLUENCER_ACCOUNT_STATUS.BLACKLISTED
              }
              onChange={(value) =>
                update({
                  influencerId,
                  influencer: {
                    accountStatus: value
                      ? INFLUENCER_ACCOUNT_STATUS.BLACKLISTED
                      : INFLUENCER_ACCOUNT_STATUS.ACTIVE,
                  },
                })
              }
              loading={isUpdating}
            />
          </Space>
        </div>
      </div>
    );
  }
  return (
    <SelectInfluencer
      handleRefetch={handleRefetch}
      socialMediaId={socialMediaId}
      categoriesToDisplay={categoriesToDisplay}
    />
  );
}
